import { render, staticRenderFns } from "./VMCFooter.vue?vue&type=template&id=4c1d28fe&scoped=true"
import script from "./VMCFooter.vue?vue&type=script&lang=js"
export * from "./VMCFooter.vue?vue&type=script&lang=js"
import style0 from "./VMCFooter.vue?vue&type=style&index=0&id=4c1d28fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1d28fe",
  null
  
)

export default component.exports